
<div >
  <form style = "padding : 0px !important" [formGroup]="userForm" #formDirective="ngForm" (ngSubmit)="onSubmit(userForm.value,formDirective)" class="text-center border border-light p-5 form" >

      <p class="h4 mb-4">Create User</p>

      <div class="card card-danger">
        <div class="card-body">
          <div class = "row">
            <div class="col-sm-6">
              <div class="form-group row ">
                <label for="Username" class="col-sm-3 col-form-label">
                  Username <span>*</span>
                </label>
                <div class="col-sm-7">
                  <!-- <p-calendar [(ngModel)]="model.InvoiceDate" [minDate]="mindate" [maxDate]="maxdate" [readonlyInput]="true" id="InvoiceDate" name="InvoiceDate"></p-calendar> -->
                  <mat-form-field appearance="outline">
                    <mat-label>Username  </mat-label>
                    <input matInput type="text" formControlName="Username" id="Username"  placeholder="User name">
                  </mat-form-field>
                </div>
              </div>
              <div class="form-group row">
                <label for="Firstname" class="col-sm-3 col-form-label">
                  First name  <span>*</span>
                </label>
                <div class="col-sm-7">
                  <!-- <p-dropdown [options]="clients" [(ngModel)]="model.clientId" [filter]="true" filterBy="label" id="ClientId" name="ClientId" [autoWidth]="true" placeholder="Select client" [showClear]="true"></p-dropdown> -->
                  <mat-form-field appearance="outline">
                    <mat-label>First name</mat-label>
                    <input matInput type="text" formControlName="Firstname" id="Firstname"  placeholder="First name">
                  </mat-form-field>
                </div>
              </div>
              <div class="form-group row">
                <label for="Lastname" class="col-sm-3 col-form-label">
                  Last name <span>*</span>
                </label>
                <div class="col-sm-7">
                  <!-- <p-dropdown [options]="clients" [(ngModel)]="model.clientId" [filter]="true" filterBy="label" id="ClientId" name="ClientId" [autoWidth]="true" placeholder="Select client" [showClear]="true"></p-dropdown> -->
                  <mat-form-field appearance="outline">
                    <mat-label>Last name </mat-label>
                    <input matInput type="text" formControlName="Lastname" id="Lastname"  placeholder="Last name">
                  </mat-form-field>
                </div>
              </div>
            </div>
            <div class="col-sm-6">
              <div class="form-group row ">
                <label for="PhoneNo" class="col-sm-3 col-form-label">
                  PhoneNo
                </label>
                <div class="col-sm-7">
                  <!-- <p-calendar [(ngModel)]="model.InvoiceDate" [minDate]="mindate" [maxDate]="maxdate" [readonlyInput]="true" id="InvoiceDate" name="InvoiceDate"></p-calendar> -->
                  <mat-form-field appearance="outline">
                    <mat-label>PhoneNo</mat-label>
                    <input matInput type="number" formControlName="PhoneNo" id="PhoneNo"  placeholder="Phone Number">
                  </mat-form-field>
                </div>
              </div>
              <div class="form-group row">
                <label for="SelectRole" class="col-sm-3 col-form-label">
                  Select Role<span>*</span>
                </label>
                <div class="col-sm-7">
                  <!-- <p-dropdown [options]="clients" [(ngModel)]="model.clientId" [filter]="true" filterBy="label" id="ClientId" name="ClientId" [autoWidth]="true" placeholder="Select client" [showClear]="true"></p-dropdown> -->
                  <mat-form-field appearance="outline" >
                    <mat-label>Select Role</mat-label>
                    <mat-select formControlName="Role">
                      <mat-option *ngFor="let role of roles" [value]="role.value">
                        {{role.viewValue}}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>
              </div>
              <div class="form-group row">
                <label for="Email" class="col-sm-3 col-form-label">
                  Email <span>*</span>
                </label>
                <div class="col-sm-7">
                  <!-- <p-dropdown [options]="clients" [(ngModel)]="model.clientId" [filter]="true" filterBy="label" id="ClientId" name="ClientId" [autoWidth]="true" placeholder="Select client" [showClear]="true"></p-dropdown> -->
                  <mat-form-field appearance="outline">
                    <mat-label>Email</mat-label>
                    <input matInput type="email" formControlName="Email" id="Email"  placeholder="E-mail">
                  </mat-form-field>

                </div>
              </div>
            </div>
          </div>
        </div>
        </div>
      <button class="btn btn-info my-4 btn-block" style="color: white; background-color: #2f72ab; font-size: 14px;" type="submit">Create User</button>
      <hr>
      </form>
  </div>
